import { AnalyticsAdminSettings, EntityStatus, YammerState, getStatus } from '../../state/types';

type GetAnalyticsAdmingSettingsStatus = (state: YammerState) => EntityStatus;
export const getAnalyticsAdminSettingsStatus: GetAnalyticsAdmingSettingsStatus = (state) =>
  getStatus(state.analyticsAdminSettings);

type GetAnalyticsAdminSettings = (state: YammerState) => AnalyticsAdminSettings | undefined;
export const getAnalyticsAdminSettings: GetAnalyticsAdminSettings = (state: YammerState) =>
  state.analyticsAdminSettings.fulfilled;

type IsOverallSentimentInLeadershipActivityEnabled = (state: YammerState) => boolean | undefined;
export const isOverallSentimentInLeadershipActivityEnabled: IsOverallSentimentInLeadershipActivityEnabled = (state) =>
  state.analyticsAdminSettings?.fulfilled?.isOverallSentimentInLeadershipActivityEnabled;

type IsSentimentPerTopThemeInLeadershipActivityEnabled = (state: YammerState) => boolean | undefined;
export const isSentimentPerTopThemeInLeadershipActivityEnabled: IsSentimentPerTopThemeInLeadershipActivityEnabled = (
  state
) => state.analyticsAdminSettings?.fulfilled?.isSentimentPerTopThemeInLeadershipActivityEnabled;

type IsSentimentPerTopThreadInLeadershipActivityEnabled = (state: YammerState) => boolean | undefined;
export const isSentimentPerTopThreadInLeadershipActivityEnabled: IsSentimentPerTopThreadInLeadershipActivityEnabled = (
  state
) => state.analyticsAdminSettings?.fulfilled?.isSentimentPerTopThreadInLeadershipActivityEnabled;

type IsTopThreadStarterSendersInCampaignActivityEnabled = (state: YammerState) => boolean | undefined;
export const isTopThreadStarterSendersInCampaignActivityEnabled: IsTopThreadStarterSendersInCampaignActivityEnabled = (
  state
) => state.analyticsAdminSettings?.fulfilled?.isTopThreadStarterSendersInCampaignActivityEnabled;

type IsTimeSavedAndPeopleHelpedInNetworkQuestionActivityEnabled = (state: YammerState) => boolean | undefined;
export const isTimeSavedAndPeopleHelpedInNetworkQuestionActivityEnabled: IsTimeSavedAndPeopleHelpedInNetworkQuestionActivityEnabled =
  (state) => state.analyticsAdminSettings?.fulfilled?.isTimeSavedAndPeopleHelpedInNetworkQuestionActivityEnabled;

type IsViewerCanEditSettings = (state: YammerState) => boolean | undefined;
export const isViewerCanEditSettings: IsViewerCanEditSettings = (state) =>
  state.analyticsAdminSettings?.fulfilled?.viewerCanEditSettings;
